import isEmpty from 'lodash/isEmpty';
import { action } from 'mobx';
import { ClassesService } from 'modules/content';
import { UiService } from 'modules/ui';
import { ALERT } from 'modules/ui/constants';

import { IMPORT_ERRORS } from './constants';

import Request from '@hotmart/request';

class ImportService {
  @action
  async importManually(data) {
    try {
      const method = 'post.member';

      await Request(method, data);

      UiService.setAlertInfo(
        'users_import.users_imported_2',
        {},
        ALERT.TIMEOUT.LONG
      );
    } catch (e) {
      UiService.handleError(e);

      return Promise.reject(e);
    }
  }

  handleError({ errorCode = '', errorDetail: limit = '' }) {
    if (errorCode === IMPORT_ERRORS.LIMIT_EXCEEDED) {
      UiService.setAlertError(
        'users_import.above_limit',
        { limit },
        ALERT.TIMEOUT.LONG
      );
    } else {
      UiService.handleError({ errorCode });
    }
  }

  @action
  importCsv(options) {
    return Request('import.csv', options)
      .then(() => {
        UiService.setAlertInfo(
          'users_import.users_imported_2',
          {},
          ALERT.TIMEOUT.LONG
        );
      })
      .catch(({ data = {} }) => {
        this.handleError(data);
      });
  }

  @action
  async hotmartImport(membershipClass) {
    if (!membershipClass || isEmpty(membershipClass)) {
      return;
    }

    try {
      await Request('import.hotmart', {
        membershipClass: membershipClass.value
      });
      UiService.setAlertInfo(
        'users_import.users_imported',
        {},
        ALERT.TIMEOUT.LONG
      );
    } catch (error) {
      this.handleError(error);
    }
  }

  @action
  async getImportHistory(options) {
    try {
      const data = await Request('get.history', options);

      delete data.numberOfElements;
      return data;
    } catch (error) {
      UiService.handleError(error);
    }
  }

  @action
  async getImportHistoryDetail(options) {
    try {
      const data = await Request('get.history_detail', options);

      delete data.numberOfElements;
      await Promise.all(
        data.content.map(async (item) => {
          item.class = await ClassesService.getClassInfo(item.membershipClass);
          return item;
        })
      );
      return data;
    } catch (error) {
      UiService.handleError(error);
    }
  }

  async getImportLimit() {
    try {
      const data = await Request('get.import_limit');

      return data;
    } catch (error) {
      UiService.handleError(error);
    }
  }

  setDefaultHours(date) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    date.setHours(12, 0, 0, 0);
  }

  isOutsideRange = (date) => {
    const today = new Date();

    this.setDefaultHours(today);
    return date.isAfter(today);
  };
}

export default new ImportService();
